import { render, staticRenderFns } from "./ReportingPerStudents.vue?vue&type=template&id=7522bd49&scoped=true&"
import script from "./ReportingPerStudents.vue?vue&type=script&lang=js&"
export * from "./ReportingPerStudents.vue?vue&type=script&lang=js&"
import style0 from "./ReportingPerStudents.vue?vue&type=style&index=0&id=7522bd49&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7522bd49",
  null
  
)

export default component.exports